module.exports = __webpack_public_path__ + "img/17.a2b95d66.png";